import utils from '@/utils/utils'
export default{
  install(Vue){

    Vue.prototype.$getHeaderType1 = function(headerTxt, headers){
      let prefix = utils.isNull(headerTxt.prefix) ? '' :  headerTxt.prefix

      headers.forEach((item, index) => {
        if (headerTxt.txt[index] === '#' || utils.isNull(headerTxt.txt[index])) {
          item.text = headerTxt.txt[index]
        } else if(this.$t(prefix + headerTxt.txt[index]) === (prefix + headerTxt.txt[index])){
          item.text = headerTxt.txt[index]
        }else{
          item.text = this.$t(prefix + headerTxt.txt[index])
        }
      })
      return headers
    },
    Vue.prototype.$getHeaderType2 = function(headerTxt, headersEn, headersAr){
      let prefix = utils.isNull(headerTxt.prefix) ? '' :  headerTxt.prefix
      let headers = this.$vuetify.rtl ? headersAr : headersEn
      headers.forEach((item, index) => {
        if (headerTxt.txt[index] === '#' || utils.isNull(headerTxt.txt[index])) {
          item.text = headerTxt.txt[index]
        } else if(this.$t(prefix + headerTxt.txt[index]) == (prefix + headerTxt.txt[index])){
          item.text = headerTxt.txt[index]
        }else{
          item.text = this.$t(prefix + headerTxt.txt[index])
        }
      })
      return headers
    }
  }
}